<core-modal-window header="Feedback zur Antwort" [modalRef]="modalRef">
  <div slot="body" class="p-md">
    <app-feedback-chips (selectedChanged)="selected = $event"></app-feedback-chips>
  </div>
  <core-modal-footer slot="footer" (aborted)="modalRef.dismiss()" (submitted)="modalRef.close(selected)"></core-modal-footer>
</core-modal-window>
